import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../../constants';

const toolbarDropdownButtonStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  h: '40px',
  minH: '40px',
  px: '12px',
  py: '10px',
  bg: BUILDER_MODE_V1_TOKENS.white,
  border: '1px solid',
  borderColor: BUILDER_MODE_V1_TOKENS.border,
  borderRadius: BUILDER_MODE_V1_LAYOUT.actionButtonRadius,
  cursor: 'pointer',
  fontFamily: BUILDER_MODE_V1_LAYOUT.toolbarFontFamily,
  fontWeight: '400',
  lineHeight: 'normal',
  boxSizing: 'border-box',
  _hover: { bg: BUILDER_MODE_V1_TOKENS.activeBg },
  _active: { bg: BUILDER_MODE_V1_TOKENS.activeBg },
};

export default toolbarDropdownButtonStyles;
